import { dangerouslyGetFeatureGateSync } from '@trello/feature-gate-client';

let isEnabled: boolean | undefined;

/**
 * Checks if the React Router feature gate is enabled.
 */
export const isReactRoutingEnabled = (): boolean => {
  if (isEnabled === undefined) {
    isEnabled = dangerouslyGetFeatureGateSync('tplat_react_router');
  }
  return isEnabled;
};
